export default {"src":"/_next/static/media/concert.f9743e6d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};